import { render, staticRenderFns } from "./UserDropDownGroup.vue?vue&type=template&id=be5b9de0&scoped=true&"
import script from "./UserDropDownGroup.vue?vue&type=script&lang=ts&"
export * from "./UserDropDownGroup.vue?vue&type=script&lang=ts&"
import style0 from "./UserDropDownGroup.vue?vue&type=style&index=0&id=be5b9de0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5b9de0",
  null
  
)

export default component.exports